export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/watercolor_pattern.e29c6da.svg";